<div
  class=" container  d-print-none "
  [ngClass]="
    pullDown
      ? 'container-fixed-lg footer pull-bottom sm-pull-bottom bg-formLogin'
      : ' m-t-10'
  "
>
  <div class="copyright sm-text-center">
    <p class="small no-margin pull-left sm-pull-reset">
      <!--<span class="hint-text">{{ "4"|translate}}</span>-->
      <!-- <span class="hint-text">{{ '4' | translate}}</span> -->
      <span class="hint-text">{{ _copyright }}</span>
      <!--<span class="hint-text">Copyright &copy; 2018 </span>-->
      <!--<span class="hint-text">All rights reserved. </span>-->
      <a class="cursorHP  " (click)="authSrv.showTermsDlg('TERMS')">{{
        "P_terms" | translate | titlecase
      }}</a>
      <span class="muted m-l-10 m-r-10 ">|</span>
      <a class="cursorHP" (click)="authSrv.showTermsDlg('PRIVACY')">{{
        "P_privacy" | translate | titlecase
      }}</a>
      <span class="muted m-l-10 m-r-10 ">|</span>
      <!--<span class="sm-block"><a href="javascript:void(0)" class="m-l-10 m-r-10">Terms of use</a> <span class="muted">|</span> <a href="javascript:void(0)" class="m-l-10">Privacy Policy</a></span>-->
    </p>
    <p class="small no-margin pull-right sm-pull-reset">
      <span class="hint-text">{{ _version }} </span>
      <!--      BCGJ STUDIO-->
    </p>
    <div class="clearfix"></div>
  </div>
</div>
